import { Box } from "@mui/material";
import React from "react";
import "./styles/common.scss";

import QuestionMark from "../assets/icons/question-mark.svg";
const FamilyTreeTutorial = (props) => {
  const { handleClick } = props;

  return (
    <>
      <Box
        onClick={handleClick}
        component="div"
        className="ft-tutorial-question-mark"
      >
        <img src={QuestionMark}></img>
      </Box>
    </>
  );
};

export default FamilyTreeTutorial;
